import { render } from "./CentersPage.vue?vue&type=template&id=00185420&ts=true"
import script from "./CentersPage.vue?vue&type=script&lang=ts"
export * from "./CentersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Centers/CentersPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00185420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00185420', __exports__)) {
    api.reload('00185420', __exports__)
  }
  
  module.hot.accept("./CentersPage.vue?vue&type=template&id=00185420&ts=true", () => {
    api.rerender('00185420', render)
  })

}


export default __exports__